import { Box, Grid } from "@mui/material";
import GapSummaryCard from "../../../../../../components/GapSummaryCard";

export default function ControlOverviewSection({ fullControl }) {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {/* ADVERSARY */}
          <Box sx={{ width: "100%" }}>
            <GapSummaryCard
              summary={fullControl?.description}
              risk={fullControl?.gap_details.adversary_perspective_risk}
              background={
                fullControl?.gap_details.adversary_perspective_context
              }
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
